import { IconButton, Tab, withStyles } from "@material-ui/core";
import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";
import { NAVBAR_HEIGHT } from "../../config";
import { MessageIDS, t } from "../../i18n/util";
import { API } from "../../network/API";
import { authStore } from "../../stores/AuthStore";
import { generalStore } from "../../stores/GeneralStore";
import { THEME } from "../../theme/ThemeStore";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { ApplicantPicture, StyledBurgerMenu } from "../ui/Primitives";

interface NavBarTabProps {
    label: string;
    value: string;
    onClick: () => void;
}

export const NavBarTab = withStyles({
    root: {
        height: NAVBAR_HEIGHT,
        paddingTop: 12,
        "&$selected": {
            color: THEME.customColors.body1Dark,
            fontWeight: 500
        }
    }
})((props: NavBarTabProps) => <Tab disableRipple {...props} />);

const handleLogout = async () => {
    try {
        generalStore.isLoading = true;
        await API.postLogout(authStore.credentials?.refresh_token);
    } catch (err) {
        generalStore.setError(t("error.logout"), err);
    } finally {
        generalStore.isLoading = false;
        authStore.logout();
    }
};

type BurgerMenuProps = {
    open: boolean;
    children: React.ReactNode;
    style?: React.CSSProperties;
};

export const BurgerMenu = observer(({ open, children, style }: BurgerMenuProps) => {
    return (
        <StyledBurgerMenu open={open} style={style} colors={THEME.customColors}>
            {children}
        </StyledBurgerMenu>
    );
});

type BurgerMenuElementProps = {
    onClick: () => void;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    label: MessageIDS;
    highlighted: boolean;
};

export const MobileMenuElementContainer = styled.div`
    height: ${NAVBAR_HEIGHT}px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const BurgerMenuElement = ({ onClick, setOpen, label, highlighted }: BurgerMenuElementProps) => (
    <MobileMenuElementContainer>
        <div
            style={{
                color: highlighted ? THEME.customColors.primary : THEME.customColors.body1Dark,
                fontWeight: highlighted ? 700 : 500,
                cursor: "pointer"
            }}
            className="body2"
            onClick={() => {
                onClick();
                setOpen(false);
            }}
        >
            {t(label)}
        </div>
    </MobileMenuElementContainer>
);

export const NavBarUserElement = () => {
    const isMobile = useMobileMediaQuery();

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                height: NAVBAR_HEIGHT,
                padding: isMobile ? 22 : 0,
                justifyContent: isMobile ? "space-between" : "flex-start",
                gap: 24
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    color: THEME.customColors.body1Dark,
                    fontWeight: 500,
                    gap: 12
                }}
                className="body2"
            >
                <ApplicantPicture
                    style={{
                        backgroundImage: `url(${authStore.pictureUrl})`,
                        height: 36,
                        width: 36
                    }}
                />
                {t("screen.navbar.hello")} {authStore.givenName}
            </div>
            <IconButton onClick={handleLogout}>
                <img src={THEME.Images.icLogout} alt="" />
            </IconButton>
        </div>
    );
};
